<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <a
        class="nav-link"
        href="/login"
        @click.prevent="logout()"
        style="text-shadow: 0px 0px 2px black"
      >
        <span class="text-danger">Salir</span
        ><i class="bi bi-door-open-fill ml-1 text-danger"></i>
      </a>
    </li>
  </ul>
</template>
<script>
import { mapActions } from 'vuex/dist/vuex.common.js'
export default {
  name: 'mobile-menu',
  methods: {
    ...mapActions(['logout'])
  }
}
</script>
<style></style>
